import React from 'react';
import image from '../assets/SignupImage.png'
// import backgroundImage from '../assets/background.png';

function App() {
  return (
    // <div className='p-5 bg-gray-300' style={{background:'#2A3A50'}}>
    // <div className='p-5 bg-gray-300' style={{background:'#2A3A50'}}>
    <div
      className="flex flex-col w-[100%] rounded-none md:rounded-[50px]  font-nunito bg-bgFeature  p-3 md:p-20 ">
      {/* // bg-cover bg-center // style={{ backgroundImage: `url(${backgroundImage})` }} */}
      <img src={image} alt="Image" className='w-[50%] lg:w-[20%] p-4' />
      <h2 className="text-xl tracking-widest md:text-xl font-bold mb-8 mt-5 p-5 pb-0 text-white">
        Subscribe To Our Newsletter 🚀
      </h2>
      {/* <p className='text-center px-5'>Sign up for exclusive updates and be the first to know about our launch and our rewards promotions.</p> */}


      <form className="p-6 mb-20 mx-auto w-[100%] ">

        <div className="mb-4">
          <input
            id="name"
            type="text"
            name="Name"
            placeholder="Name"
            className="w-full px-3 py-2 focus:border rounded-[100px] px-10 outline-none ring-1 ring-[#ae92d2] h-[50px]" style={{ color: 'black' }}
          />
        </div>

        <div className="mb-6">
          <input
            id="email"
            type="email"
            name='email'
            placeholder="Email"
            className="w-full px-3 py-2 focus:border rounded-[100px] px-10 outline-none ring-1 ring-[#ae92d2] h-[50px] " style={{ color: 'black ' }}
          />
        </div>

        <button
          type="submit"
          className="w-full font-bold py-2 rounded-[100px] bg-[#ae92d2] hover:bg-white hover:bg-white hover:text-[black] text-white transition-colors duration-300"
        >
          Sign Up
        </button>

      </form>
    </div>
    // </div>

  );
}

export default App;
